import { HttpClient, HttpClientRequest, HttpClientResponse } from '@effect/platform';
import { Schema } from '@effect/schema';
import { MerklCampaign } from '@silo/data';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import { Effect, pipe } from 'effect';

export const merklCampaignsKey = 'merklCampaigns';

type MerklCampaignsKey = [key: typeof merklCampaignsKey];

export const useQueryMerklCampaigns = () => {
  return useQuery({
    queryKey: [merklCampaignsKey],
    queryFn: queryMerklCampaigns,
  });
};

const queryMerklCampaigns: QueryFunction<MerklCampaign[], MerklCampaignsKey> = async () => {
  const result = await pipe(
    HttpClientRequest.get('/api/get-merkl-campaigns'),
    HttpClient.fetchOk,
    Effect.andThen(HttpClientResponse.schemaBodyJson(Schema.mutable(Schema.Array(MerklCampaign)))),
    Effect.scoped,
    Effect.runPromise
  );

  return result;
};
